import { render, staticRenderFns } from "./WardContact.vue?vue&type=template&id=03998c6c&scoped=true&"
import script from "./WardContact.vue?vue&type=script&lang=js&"
export * from "./WardContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03998c6c",
  null
  
)

export default component.exports